export const notifications = {
  new: "new",
  alerts: "Alerts",
  events: "Events",
  logs: "Logs",
  notifications: "Notifications"
};
